import { Link, NavLink } from 'react-router-dom';
import Logo from '../../img/graphics/NAS Logo Color smaller.png';
import { links, detailsDonate } from '../../data/Data';
import './Navbar.css';
import { HiOutlineBars3CenterLeft, HiXMark } from "react-icons/hi2";
import React, { useState, useEffect, useRef } from 'react';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const closeTimer = useRef(null);

  useEffect(() => {
    if (showModal) {
      const scriptId = 'give-lively-script';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://secure.givelively.org/widgets/branded_donation/national-aphasia-synergy-inc.js';
        script.async = true;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }, [showModal]);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // Get the donate button config from detailsDonate
  const donateConfig = detailsDonate.find(item => item.id === 'gLively-donate-btn');

  const handleMouseEnter = (index) => {
    clearTimeout(closeTimer.current);
    setDropdownOpen(index);
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => {
      setDropdownOpen(null);
    }, 200);
  };

  const toggleMenu = () => setMenuOpen(prev => !prev);

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(null);
  };

  return (
    <>
      <nav>
        {/* Overlay — closes menu when tapping outside */}
        <div
          className={`nav__overlay${menuOpen ? ' nav--open' : ''}`}
          onClick={closeMenu}
        />

        <div className="nav__container">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src={Logo} alt="NAS logo" />
          </Link>

          <ul className={`nav__links${menuOpen ? ' nav--open' : ''}`}>
            {links.map(({ name, path, subLinks }, index) => (
              <li
                key={index}
                className="nav__item"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <NavLink
                  to={path}
                  className="nav__link"
                  onClick={closeMenu}
                >
                  {name}
                </NavLink>

                {/* Always render sublinks in DOM — CSS controls visibility */}
                {subLinks && (
                  <ul className={`dropdown-menu${dropdownOpen === index ? ' dropdown--open' : ''}`}>
                    {subLinks.map((sub, subIndex) => (
                      <li key={subIndex}>
                        <NavLink
                          to={sub.path}
                          className="dropdown-link"
                          onClick={closeMenu}
                        >
                          {sub.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

            <li key="donate">
              <button
                className="nav-button"
                onClick={() => { openModal(); closeMenu(); }}
                style={donateConfig?.style}
              >
                {donateConfig?.donate || 'Donate'}
              </button>
            </li>
          </ul>

          <button
            className="nav__toggle-btn"
            onClick={toggleMenu}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <HiXMark /> : <HiOutlineBars3CenterLeft />}
          </button>
        </div>
      </nav>

      {/* Donation Modal */}
      {showModal && (
        <div className="donation-modal-overlay">
          <div className="donation-modal">
            <button className="donation-modal-close" onClick={closeModal}>
              &times;
            </button>
            <div
              data-widget-src="https://secure.givelively.org/donate/national-aphasia-synergy-inc?ref=sd_widget"
              id="give-lively-widget"
              className="gl-branded-donation-widget"
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;